import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import React, { useEffect, useState } from 'react';
import './index.scss';

interface StripeProviderProps {
    stripePublicKey: string;
    children: React.ReactNode;
}

const StripeProvider: React.FC<StripeProviderProps> = ({ stripePublicKey, children }) => {
    const [stripePromise, setStripePromise] = useState<any>(null);
    const [loadError, setLoadError] = useState<string | null>(null);

    useEffect(() => {
        if (!stripePublicKey) {
            return;
        }
        try {
            const stripeInstance = loadStripe(stripePublicKey);
            setStripePromise(stripeInstance);
        } catch (error) {
            console.error('Failed to initialize payment system', error);
            setLoadError('Failed to initialize payment system. Please try again later.');
        }
    }, [stripePublicKey]);

    if (loadError) {
        return <div className="stripe-load-error">{loadError}</div>;
    }

    if (!stripePromise) {
        return <div className="stripe-loading">Loading payment system...</div>;
    }

    return <Elements stripe={stripePromise}>{children}</Elements>;
};

export default React.memo(StripeProvider);
